import ClientLayout from 'views/client/layout';
import DashboardDefault from 'views/client/dashboard';
import Returns from 'views/client/returns';
import ReturnsDetails from 'views/client/returns/ReturnsDetails';
import Quotations from 'views/client/quotations';
import QuotationDetails from 'views/client/quotations/QuotationDetails';
import Invoices from 'views/client/Invoices';
import InvoiceDetails from 'views/client/Invoices/InvoiceDetails';
import SalesOrders from 'views/client/sales-orders';
import SalesOrderDetails from 'views/client/sales-orders/SalesOrderDetails';
import CompanyDetails from 'views/client/company-details';
import Settings from 'views/client/settings';
import CompanyAddress from 'views/client/company-details/components/CompanyAddress';
import CompanyDocuments from 'views/client/company-details/components/Documents';
import CompanyBankDetails from 'views/client/company-details/components/BankDetails';
import CompanyEndDetails from 'views/client/company-details/components/End';
import VerificationCompleted from 'views/client/company-details/components/VerificationCompleted';
import CompanyInfo from 'views/client/settings/components/CompanyInfo';
import CompanyAddressSettings from 'views/client/settings/components/CompanyAddress';
import CompanyBankSettings from 'views/client/settings/components/CompanyBank';
import SurveyDetails from 'views/client/company-details/components/Survey';
import CompanyPreferenceSettings from 'views/client/settings/components/CompanyPreference';
import Cart from 'views/client/cart';
import LanguageSwitcher from '../ui-component/LanguageSwitcher';
import Serials from 'views/client/serials';
import Shipments from 'views/client/Shipments';

// ✅ Clear
// ===========================|| Client ROUTING ||=========================== //
const ClientRoutes = {
	path: '/',
	element: <ClientLayout />,
	children: [
		{
			path: 'client/portal',
			children: [
				{
					path: '',
					element: (
						// <Auth>
						<DashboardDefault />
						// </Auth>
					)
				}
			]
		},
		{
			path: 'client/dashboard',
			children: [
				{
					path: '',
					element: (
						// <Auth>
						<DashboardDefault />
						// </Auth>
					)
				}
			]
		},
		{
			path: 'client/returns',
			children: [
				{
					path: '',
					element: (
						// <Auth>
						<Returns />
						// </Auth>
					)
				},
				{
					path: 'create',
					element: <ReturnsDetails />
				},
				{
					path: ':id',
					element: <ReturnsDetails edit />
				}
			]
		},
		{
			path: 'client/cart',
			children: [
				{
					path: '',
					element: (
						// <Auth>
						<Cart />
						// </Auth>
					)
				}
			]
		},

		{
			path: 'client/quotations',
			children: [
				{
					path: '',
					element: <Quotations />
				},
				{
					path: ':id',
					element: <QuotationDetails />
				}
			]
		},

		{
			path: 'client/invoices',
			children: [
				{
					path: '',
					element: (
						// <Auth>
						<Invoices />
						// </Auth>
					)
				},
				{
					path: ':id',
					element: <InvoiceDetails />
				}
			]
		},
		{
			path: 'client/serials',
			children: [
				{
					path: '',
					element: (
						// <Auth>
						<Serials />
						// </Auth>
					)
				}
			]
		},
		{
			path: 'client/shipments',
			children: [
				{
					path: '',
					element: (
						// <Auth>
						<Shipments />
						// </Auth>
					)
				}
			]
		},
		{
			path: 'client/sales-orders',
			children: [
				{
					path: '',
					element: (
						// <Auth>
						<SalesOrders />
						// </Auth>
					)
				},
				{
					path: ':id',
					element: <SalesOrderDetails />
				}
			]
		},
		{
			path: 'client/company-details',
			children: [
				{
					path: '',
					element: (
						// <Auth>
						<CompanyDetails />
						// </Auth>
					)
				}
			]
		},
		{
			path: 'client/settings',
			children: [
				{
					path: '',
					element: (
						// <Auth>
						<Settings />
						// </Auth>
					)
				}
			]
		},
		{
			path: 'client/settings/company-info',
			children: [
				{
					path: '',
					element: (
						// <Auth>
						<CompanyInfo />
						// </Auth>
					)
				}
			]
		},
		{
			path: 'client/settings/company-address',
			children: [
				{
					path: '',
					element: (
						// <Auth>
						<CompanyAddressSettings />
						// </Auth>
					)
				}
			]
		},
		{
			path: 'client/settings/company-bank',
			children: [
				{
					path: '',
					element: (
						// <Auth>
						<CompanyBankSettings />
						// </Auth>
					)
				}
			]
		},
		{
			path: 'client/settings/company-preference',
			children: [
				{
					path: '',
					element: (
						// <Auth>
						<CompanyPreferenceSettings />
						// </Auth>
					)
				}
			]
		},
		{
			path: 'client/company-address',
			element: (
				// <Auth>
				<CompanyAddress />
				// </Auth>
			)
		},
		{
			path: 'client/company-documents',
			element: (
				// <Auth>
				<CompanyDocuments />
				// </Auth>
			)
		},
		{
			path: 'client/company-bank-details',
			element: (
				// <Auth>
				<CompanyBankDetails />
				// </Auth>
			)
		},
		{
			path: 'client/company-survey-details',
			element: (
				// <Auth>
				<SurveyDetails />
				// </Auth>
			)
		},
		{
			path: 'client/company-end-details',
			element: (
				// <Auth>
				<CompanyEndDetails />
				// </Auth>
			)
		},
		{
			path: 'client/company-verified',
			element: (
				// <Auth>
				<VerificationCompleted />
				// </Auth>
			)
		},
		{
			path: 'client/settings/languages',
			element: (
				<LanguageSwitcher />
			)
		}
	]
};

export default ClientRoutes;
